import images from "./images";

const profile = {
  name: "Richard Ellison",
  email: "abc@gmail.com",
  phone: "0123456789",
  profileImage: images.profile,

  shippingAddress: {
    name: "Richard Ellison",
    country: "pakistan",
    city: "karachi",
    province: "sindh",
    zip: "12345",
    street: "3rd Floor, A.B.C Society, High Road"
  },

  billingAddress: {
    name: "Richard Ellison",
    country: "pakistan",
    city: "karachi",
    province: "sindh",
    zip: "12345",
    street: "3rd Floor, A.B.C Society, High Road"
  }
};

export default profile;